export default {
  common: {
    report: 'Report',
    poweredBy: 'Powered by',
    currencyIs: 'Currency is',
  },
};
